import { render } from "./PayoutsManage.vue?vue&type=template&id=1a8738c4&scoped=true"
import script from "./PayoutsManage.vue?vue&type=script&lang=js"
export * from "./PayoutsManage.vue?vue&type=script&lang=js"

import "./PayoutsManage.vue?vue&type=style&index=0&id=1a8738c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8738c4"]])

export default __exports__